import React from 'react'

const Frontend = () => {
  return (
    <div className="skills-content">
        <h3 className="skills-title ">Frontend </h3>
        <div className="skills-box">
            <div className="skills-group">
                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">HTML</h3>
                    {/* <span className="skills-level">Advanced</span> */}
                </div>
                </div>
                

                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">CSS</h3>
                    {/* <span className="skills-level">Intermediate</span> */}
                </div>
                </div>
               

                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Bootstrap</h3>
                    {/* <span className="skills-level">Intermediate</span> */}
                </div>
                </div>
                 <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Javascript</h3>
                    {/* <span className="skills-level">Intermediate</span> */}
                </div>
                </div>
               
            </div>

            <div className="skills-group">
                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Tailwind</h3>
                    {/* <span className="skills-level">Basic</span> */}
                </div>
                </div>
                

                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">React</h3>
                    {/* <span className="skills-level">Basic</span> */}
                </div>

                </div>
                
                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">UI/UX</h3>
                    {/* <span className="skills-level">Intermediate</span> */}
                </div>
                </div>
                
 <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Typescript</h3>
                    {/* <span className="skills-level">Intermediate</span> */}
                </div>
                </div>
                
            </div>
        </div>
    </div>
  )
}

export default Frontend
